import React, { Component } from "react";

class TemplateSelection extends Component {
  state = {};

  _displayTemplates = () => {
    const { loading, templates } = this.props;

    // Show loading message
    if (loading) {
      return (
        <div className="quote-create-template-selection">
          <span className="loader-label"> Loading templates . . . . </span>
        </div>
      );
    }
    // If there are no templates for the category selected
    if (this.props.templates.length === 0) {
      return (
        <div className="from-template">
          <div className="no-template-label">
            No templates are available for this category
            <span role="img" aria-label="Sad">
              😕
            </span>
          </div>
        </div>
      );
    }

    return (
      <div className="quote-create-template-selection">
        {Array.isArray(templates) &&
          templates.map(template => (
            <div
              key={template.id}
              className="quote-create-template"
              id={template.title.replace(/ +/g, "-").toLowerCase()}
              onClick={() => this.props.createDoc(template)}
              onKeyPress={() => {}}
              role="button"
              tabIndex="0">
              <div
                data-test="templateselection-templatecard"
                className="quote-create-templatecard">
                <img src={`${template.thumbnail}`} alt={`${template.title}`} />
                {template.template_type === "form" && (
                  <div className="quote-create-badgewrapper">
                    <span className="quote-create-badge">Form</span>
                  </div>
                )}
              </div>

              <div className="quote-create-templatecardname">
                {template.title}
              </div>
            </div>
          ))}
        {/* <div
          className="quote-create-template"
          onClick={() => this.props.setView(false)}>
          <div className="quote-create-owndoc">
            <div className="quote-create-template-plus">
              <span>
                <FontAwesomeIcon
                  icon={["far", "plus"]}
                  className="quote-create-template-plus-btn"
                />
              </span>
            </div>
            <div className="quote-create-template-plus-text">
              Use your template <br /> Upload .docx
            </div>
          </div>
        </div> */}
      </div>
    );
  };

  render() {
    return (
      <div
        className="quote-create-template-selection-wrapper"
        data-test="templateselection-quote-create-template-selection-wrapper">
        {this._displayTemplates()}
      </div>
    );
  }
}

export default TemplateSelection;
